import { render, staticRenderFns } from "./PendencyCommentNew.vue?vue&type=template&id=00525ad4"
import script from "./PendencyCommentNew.vue?vue&type=script&lang=js"
export * from "./PendencyCommentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports